module.exports = __webpack_public_path__ + "static/media/Waveform_inverted.369572ce.svg";